import { Select } from './Select';
import type { InputLabel } from './InputWrapper';
import { Currency } from '~/graphql/graphql';

export const CURRENCIES = Object.values(Currency);

interface CurrencySelectorProps {
  name: string;
  value: string;
  onChange: (name: string, value: string) => void;
  label?: InputLabel;
  disabled?: boolean;
}

export function CurrencySelector({
  name,
  value,
  onChange,
  label,
  disabled,
}: CurrencySelectorProps) {
  return (
    <Select
      name={name}
      value={value}
      onChange={onChange}
      label={label}
      disabled={disabled}
      options={CURRENCIES.map((c) => ({ value: c, label: c }))}
    />
  );
}
